import {inputDialog,covertSecondsToMinsSecs,_str} from 'h2g-test-results/js/util';
import $ from 'jquery';

angular.module('WTG.DIALOG',[]).factory('WTGDIALOG',function($mdDialog) {
 var wtg_dialog = {
  open_simple_dialog  : function(inputCtrl,message){
   wtg_dialog.create_dialog(inputCtrl,message,C11N.root_path +'h2g-material/dialogs/InputDialog.html');
  },
  open_multi_dialog : function(inputCtrl,message){
   wtg_dialog.create_dialog(inputCtrl,message,C11N.root_path +'h2g-material/dialogs/MultiControlInputDialog.html');
  },
  create_dialog  : function(inputCtrl,message,template){
   var multiple_popups = message && message.multiple;
   $mdDialog.show({
    controller: inputCtrl,
    templateUrl: template,
    parent: angular.element(document.body),
    multiple: multiple_popups,
    locals : {
     message : message
    },
    clickOutsideToClose:false
   });
   inputDialog.restrict = message && message.restrict;
   inputDialog.hide = $mdDialog.hide.bind($mdDialog);
  },
  gen_popup : function gen_popup($scope, $mdDialog, $rootScope, $timeout, message) {
  L.trace("message--"+JSON.stringify(message));
   $scope.is_portal = C11N.is_portal;
   $scope.hed_icon = false;
   $scope.template_header = message.header;
   $scope.template_body = message.body;
   $scope.controller = message.controller;
   $scope.action_btn_two = message.btn_one;
   $scope.hide_btn_two = !message.btn_two;
   $scope.hide_btn_three = !message.btn_three;
   $scope.action_btn_one = message.btn_two;
   $scope.action_btn_three = message.btn_three;
   $scope.cancel = $mdDialog.cancel.bind($mdDialog);
   $scope.hide = function() {
    $mdDialog.hide();
    L.trace("btn two");
    if(message.cb_two) message.cb_two(message.btn_two,message.rid);
   };
   $scope.setValue = function(/*answer*/) {
     $mdDialog.hide();
     L.trace("btn one");
     if(message.cb_one) message.cb_one(message.btn_one,message.rid);
   };
   $scope.btn_three_click = function() {
    $mdDialog.hide();
    L.trace("btn three");
    if(message.cb_three) message.cb_three(message.btn_three,message.rid);
   };
  },
  open_custom_dialog  : function(inputCtrl,message){
   wtg_dialog.create_custom_dialog(inputCtrl,message);
  },
  create_custom_dialog  : function(inputCtrl,message){
   var parentEl;
   if(!C11N.is_portal) {
    parentEl = document.getElementById("mdDialogOverLayScreen");
    parentEl.style.display = "block";
   }
   $mdDialog.show({
    parent: C11N.is_portal ?  angular.element(document.body) : parentEl,
    closeDialog:message.busyStateHandle,
    testName:message.testName,
    controller: inputCtrl,
    templateUrl: C11N.root_path +'h2g-material/dialogs/CustomDialog.html',
    clickOutsideToClose:false,
    onRemoving: !C11N.is_portal && dialog_close_event,
    onShowing : !C11N.is_portal && dialog_onShowing_event,
    multiple: false,
    locals : {
     message : message
    }
   });
   function dialog_close_event(/*scope, element, options*/) {
    parentEl.style.display = "none";
   }
   function dialog_onShowing_event(/*scope, element, options*/) {
    parentEl.style.display = "block";
   }
   inputDialog.restrict = message && message.restrict;
   inputDialog.hide = $mdDialog.hide.bind($mdDialog);
  },
  custom_popup : function gen_popup($scope, $mdDialog, $rootScope, $timeout, message) {
   //L.trace("custom_popup-message--"+JSON.stringify(message));
   $scope.controller = message.ctrl;
   $scope.menuItems = message.items;
   $scope.is_portal = C11N.is_portal;
   $scope.cancel = $mdDialog.cancel.bind($mdDialog);
   $scope.onItemClick = function(sv) {
    if(message.cb_item_click) message.cb_item_click(sv);
    $mdDialog.hide();
   };
  },
  open_generic_dialog  : function(inputCtrl,message){
   wtg_dialog.create_generic_dialog(inputCtrl,message);
  },
  create_generic_dialog  : function(inputCtrl,message){
   $mdDialog.show({
    controller: inputCtrl,
    templateUrl: C11N.root_path +'h2g-material/dialogs/GenericOverlay.html',
    fullscreen: true,
    locals: {message : message}
   });
  },
  generic_popup : function gen_popup($scope, $mdDialog, $rootScope, $timeout, message) {
   L.trace("custom_popup-message--"+JSON.stringify(message));
   $scope.gen_overlay_screen = message.ctrl;
   $scope.is_portal = C11N.is_portal;
   $scope.header = message.title;
   $scope.details = message.desc;
   $scope.logPath = message.r;
   $scope.ok = message.btn;
   $scope.cancel = $mdDialog.cancel.bind($mdDialog);
   $scope.btnClick = function(){
    if(message.cb_item_click) message.cb_btn_click();
    $mdDialog.hide();
   };
  },
  input_ctrl : function upDatePopUpDialogContent($scope, $mdDialog,$rootScope,$timeout, message) {
   $scope.is_portal = C11N.is_portal;
   $scope.hed_icon = false;
   $scope.template_header = message.header;
   $scope.template_body = message.body;
   $scope.settingsValue = message.current_val;
   $scope.input_postfix = message.pf;
   $scope.controller = message.controller;
   $scope.min_val =  message.min;
   $scope.max_val =  message.max ;
   $scope.step = message.step;
   $scope.placeholder_str = message.placeholder;
   $scope.action_btn_two = message.btn_one;
   $scope.hide_btn_two = !message.btn_two;
   $scope.hide_btn_three = !message.btn_three;
   $scope.action_btn_one = message.btn_two;
   $scope.action_btn_three = message.btn_three;
   $scope.cancel = $mdDialog.cancel.bind($mdDialog);
   $scope.hide = function() {
   $mdDialog.hide();
   L.trace("btn two");
   if(message.cb_two) message.cb_two(message.btn_two,message.rid);
   };
   $scope.setValue = function(val) {
     $mdDialog.hide();
     L.trace("btn one");
     if(message.cb_one) message.cb_one(val);
   };
   $scope.btn_three_click = function() {
    $mdDialog.hide();
    L.trace("btn three");
    if(message.cb_three) message.cb_three(message.btn_three,message.rid);
   };
   $scope.getPostfix = function(time){
    if(_TDC) return (time+" "+ $rootScope.strings.settings_time_unit_min);
    return covertSecondsToMinsSecs(time);
   };
  },
  locationListCtrl : function upDatePopUpDialogContent($scope, $mdDialog,$rootScope,$timeout, message) {
   //L.trace('-cbone-message-'+JSON.stringify(message));
   $scope.hideRadioGroup = true;
   $scope.locations = [];
   var default_locations = {
    "Living room":[],"Bedroom":[],"Kitchen":[],
    "Dining room":[],"Garage":[],"Workspace ":[],
    "Cellar":[],"Lift":[],"Balcony":[],"Study":[],
    "Office space":[]
   };
   NativeAPI.call_engine('network.location.get',{},function(e,r) {
    $scope.hideRadioGroup = false;
    $('.removeMargin').css({"margin-top" :"-3rem"});
    var loc_from_storage = r;
    if(default_locations) Object.assign(default_locations , loc_from_storage);
    else L.trace('No default locations');
    for(var x in default_locations){
     var o = {name:x,value:default_locations[x]};
     $scope.locations.push(o);
    }
    L.trace('locations-'+JSON.stringify($scope.locations));
   });
   $scope.is_portal = C11N.is_portal;
   $scope.hed_icon = false;
   $scope.disableIf = false;
   $scope.type_your_own_str = _str("type_your_own_location");
   $scope.template_header = message.header;
   $scope.template_body = message.body;
   $scope.controller = message.controller;
   $scope.action_btn_two = message.btn_one;
   $scope.action_btn_one = message.btn_two;
   $scope.cancel = $mdDialog.cancel.bind($mdDialog);
   $scope.enable_field = function(){
    $scope.disableIf = false;
   };
   $scope.disable_field = function(){
    $scope.disableIf = true;
   };
   $scope.hide = function() {
   $mdDialog.hide();
    L.trace("btn two");
    if(message.cb_two) message.cb_two(message.btn_two,message.rid);
   };
   $scope.setValue = function(val) {
    $mdDialog.hide();
    L.trace("btn one");
    if(message.cb_one) message.cb_one(val);
   };
  },
  close_dialog : function closeDialog() {
   $mdDialog.hide();
  },
 };
 return wtg_dialog;
});

//TODO : All md dialogs content needs to be move in this module.
// first only we moved what we used in speed test module
